import React from "react";
import { Route } from "react-router";

export default (
  <Route path="/:url" />
);
